import '../../../../../common/assets/js/imports.js';

// import firebase from 'firebase/app';
// import 'firebase/messaging';

// import { LSFirebaseNotifications } from '../firebaseNotifications.js';
import { LSCMSUtils } from '../utils.js';
import { LSMegaMenu } from '../megaMenu.js';
import { LSBlogList } from '../blogList.js';
import { GAEECommerce } from '../../snippets/gaEECommerce.js';
import { facebookECommerce } from '../../snippets/facebookECommerce.js';
import '../../css/megaMenu.css';
import '../../css/stepper.css';
import '../../css/profile.css';
import '../../css/foldersList.css';
import '../../css/blog.css';

// window.firebase = firebase;
// window.LSFirebaseNotifications = LSFirebaseNotifications;
window.LSCMSUtils = LSCMSUtils;
window.LSMegaMenu = LSMegaMenu;
window.LSBlogList = LSBlogList;
window.GAEECommerce = GAEECommerce;
window.facebookECommerce = facebookECommerce;